import { Box, Button } from '@mui/material';
import { type CaregiverSearchResultWithURL } from '@/types/SearchDirectory';
import { LatestReview } from '@/components/feature/searchDirectory/LatestReview';
import { CaregiverOverview } from './CaregiverOverview';
import { CaregiverExperienceSummary } from './CaregiverExperienceSummary';
import { CaregiverServices } from './CaregiverServices';

export interface CaregiverCardFullProps {
  searchResult: CaregiverSearchResultWithURL;
}

export const CaregiverCardFull = ({ searchResult }: CaregiverCardFullProps) => {
  const { caregiver } = searchResult;
  const bio = caregiver.profiles?.commonCaregiverProfile?.bio;
  return (
    <Box
      width="100%"
      p={3}
      borderRadius={6}
      sx={{ mt: 4, '&:first-of-type': { mt: 0 } }}
      bgcolor="background.primary">
      <CaregiverOverview searchResult={searchResult} />
      <CaregiverServices sx={{ mt: 2 }} caregiver={searchResult.caregiver} />

      {bio?.experienceSummary && (
        <CaregiverExperienceSummary
          sx={{ mt: { sm: 3 } }}
          experienceSummary={bio.experienceSummary}
          isAIAssistedBio={bio.aiAssistedBio ?? false}
        />
      )}
      <Box
        mt={2}
        display="flex"
        justifyContent={searchResult.latestReview ? 'space-between' : 'flex-end'}
        alignItems="flex-end">
        {searchResult.latestReview && <LatestReview latestReview={searchResult.latestReview} />}

        <Button
          href={searchResult.profileURL}
          target="_blank"
          size="medium"
          sx={{ minWidth: '160px', ml: searchResult.latestReview ? 4 : 0 }}
          color="primary"
          variant="contained">
          See&nbsp;profile
        </Button>
      </Box>
    </Box>
  );
};
export default CaregiverCardFull;
